<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode"　:funcKeyUp='bindKeyUpInterface'></ParseForm>
      </template>
      <div style="margin-left: 15px; margin-right: 8px">
        <div class="row" >
          <ejs-checkbox ref='pgwEnable' :label='pgw.enableLabel' :change='onCheckBoxChange' ></ejs-checkbox>
        </div>
        <div class="row">
          <div class="h-borderBox">
            <div class="h-borderBox-content" style="margin-top: 20px;">
              <ejs-radiobutton :label='pgw.addrLabel' value="0" :checked="pgw.addrChecked" :change="onRadioButtonChange" :disabled="!pgw.checked" ></ejs-radiobutton>
              <div style="margin-top: 10px;">
              <template>
                <ParseForm ref="pgwAddr" :formId="formItems.pgwAddr.formId" :formParams="formItems.pgwAddr.formObj" formPattern="2" :opCode="opCode"></ParseForm>
              </template>
              </div>
              <div style="margin-top: -20px;">
                <ejs-radiobutton :label='pgw.hostLabel' value="1" :checked="pgw.hostChecked" :change="onRadioButtonChange" :disabled="!pgw.checked"></ejs-radiobutton>
              </div>
              <div style="margin-top: 10px;">
              <template>
                <ParseForm ref="pgwHost" :formId="formItems.pgwHost.formId" :formParams="formItems.pgwHost.formObj" formPattern="2" :opCode="opCode"></ParseForm>
              </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ParseForm from '../../../util/parseFormNew/ParseForm';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "AddProfileForm",
  components: {
    ParseForm,
  },
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {

          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.pgwAddr) {
        if (!this.$refs.pgwAddr.validateResult()) {

          return;
        }
        const maps = this.$refs.pgwAddr.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.pgwHost) {
        if (!this.$refs.pgwHost.validateResult()) {

          return;
        }
        const maps = this.$refs.pgwHost.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      console.log(map);
      return map;
    },
    getJson(ne, callback) {
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.addPdnProfileJson, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(res, []);
        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        this.formItems.pgwAddr.formObj = resultMap.get(this.formItems.pgwAddr.modelName);
        this.formItems.pgwHost.formObj = resultMap.get(this.formItems.pgwHost.modelName);

        this.timer1 = setTimeout(() => {
          this.bindEventsAfterPageCreated();
        }, 200);

        callback(response);
      });
    },
    saveProfile(ne, callback) {
      const formData = this.getDatas();
      if (formData) {
        const params = {
          vo: {
            neid: ne.neid,
            aPNAMBR_DL: formData.get("aPNAMBR_DL"),
            aPNAMBR_UL: formData.get("aPNAMBR_UL"),
            aPNName: formData.get("aPNName"),
            aRP: this.getArp(formData),
            charging_Characteristics: parseInt(formData.get("charging_Characteristics"),16),
            pDNType: formData.get("pDNType"),
            pgw_host_name: formData.get("pgw_host_name"),
            pgw_ipv4_addr: formData.get("pgw_ipv4_addr"),
            pgw_ipv6_addr: formData.get("pgw_ipv6_addr"),
            pgw_realm_name: formData.get("pgw_realm_name"),
            pgwchose: this.pgw.checked ? "on" : "off",
            profileId: formData.get("profileId"),
            profileName: formData.get("profileName"),
            qCI: formData.get("qCI"),
            vplmnAllowed: formData.get("vplmnAllowed"),
          },
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          },
          log: {
            module: 'res.subscriber#res.subscriber_lte#res.subscriber_lte_pdn',
            execFunName: 'subscriber.epcAddPDN',
            exectype: 1,
            execData: [formData.get("aPNName")]
          }
        };
        this.$axios.post(ajaxUrl.requestCommon, params).then((response) => {
          if (callback) {
            callback(response);
          }
        });
      }
    },
    getArp(formData) {
      if (formData) {
        const bit6 = parseInt(formData.get("aRP[6]"), 10);
        const bit2_5 = parseInt(formData.get("aRP[2-5]"), 10);
        const bit0 = parseInt(formData.get("aRP[0]"), 10);
        const aRP = (bit6 << 6) + (bit2_5 << 2) + bit0;
        return aRP;
      }
      return 0;
    },
    reMount() {
      this.$refs.basic.reMount();
      this.$refs.pgwAddr.reMount();
      this.$refs.pgwHost.reMount();
    },
    bindEventsAfterPageCreated() {
      this.updatePgwDisabled();
    },
    onRadioButtonChange(args) {
      this.pgw.addrChecked = args.value === "0";
      this.pgw.hostChecked = args.value === "1";
      if(this.pgw.addrChecked) {
        this.clearPgwHost();
      }
      if(this.pgw.hostChecked) {
        this.clearPgwAddr();
      }
      this.updatePgwDisabled();
    },
    onCheckBoxChange(args) {
      this.pgw.checked = args.checked;
      this.pgw.addrChecked = true;
      this.pgw.hostChecked = false;
      if (!this.pgw.checked) {
        this.clearPgwHost();
        this.clearPgwAddr();
      }
      this.updatePgwDisabled();
    },
    clearPgwHost() {
      const component = this.$refs.pgwHost;
      if (component) {
        component.setData('pgw_host_name', '');
        component.setData('pgw_realm_name', '');
      }
    },
    clearPgwAddr() {
      const component = this.$refs.pgwAddr;
      if (component) {
        component.setData('pgw_ipv4_addr', '');
        component.setData('pgw_ipv6_addr', '');
      }
    },
    updatePgwDisabled() {
      this.$refs.pgwAddr.setAttrByName('pgw_ipv4_addr','disabled', !this.pgw.checked || !this.pgw.addrChecked);
      this.$refs.pgwAddr.setAttrByName('pgw_ipv6_addr','disabled', !this.pgw.checked || !this.pgw.addrChecked);

      this.$refs.pgwHost.setAttrByName('pgw_host_name','disabled', !this.pgw.checked || !this.pgw.hostChecked);
      this.$refs.pgwHost.setAttrByName('pgw_realm_name','disabled', !this.pgw.checked || !this.pgw.hostChecked);
    },
    bindUtf8CodeLengthRegex(name, maxLength) {
      const $this = this;
      this.funcKeyUpMap.set(name, () => {
        const _rule = {
          regex: [$this.regex.char, $this.$t('MCS.noSpecialChar')]
        };
        $this.$refs.basic.removeValidate(name);
        $this.$refs.basic.setValidate(name, _rule);
        if ($this.$refs.basic.validateResult([name]) === true) {
          if ($this.utf8Length($this.$refs.basic.getDatas().get(name), maxLength) === false) {
            const _utf8Rule = {
              regex: [$this.regex.noMatchRegex, this.$t('Profile.charAt32')]
            };
            $this.$refs.basic.removeValidate(name);
            $this.$refs.basic.setValidate(name, _utf8Rule);
          }
        }
      });
    },
    utf8Length(inputStr, maxLength) {
      let totalLength = 0;
      /* 计算utf-8编码情况下的字符串长度 */
      for (let i = 0; i < inputStr.length; i++) {
        if (inputStr.charCodeAt(i) <= parseInt(0x7F)) {
          totalLength += 1;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x7FF')) {
          totalLength += 2;
        } else if (inputStr.charCodeAt(i) <= parseInt('0xFFFF')) {
          totalLength += 3;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x1FFFFF')) {
          totalLength += 4;
        } else if (inputStr.charCodeAt(i) <= parseInt('0x3FFFFFF')) {
          totalLength += 5;
        } else {
          totalLength += 6;
        }
      }
      return totalLength <= maxLength;
    },
  },
  computed:{
    bindKeyUpInterface() {
      this.funcKeyUpMap = new Map();
      this.bindUtf8CodeLengthRegex('profileName', 32);
      return this.funcKeyUpMap;
    },
  },
  data() {
    return {
      regex: {
        char: '^[a-zA-Z0-9\u4e00-\u9fa5]+$',
        noMatchRegex: '^@_-@_-@_-@_-@_-@_$'
      },
      funcKeyUpMap:null,
      pgw: {
        enableLabel: this.$t("PDN.pgwEnableLabel"),
        addrLabel: this.$t("PDN.pgwAddrLabel"),
        hostLabel: this.$t("PDN.pgwHostLabel"),
        checked: false,
        addrChecked: true,
        hostChecked: false,
        test: true
      },
      formItems: {
        basic: {
          formId: "PdnAddBasicInfo",
          modelName: "basic",
          formObj: null,
        },
        pgwAddr: {
          formId: "PdnAddPgwAddr",
          modelName: "pgwAddr",
          formObj: null,
        },
        pgwHost: {
          formId: "PdnAddPgwHost",
          modelName: "pgwHost",
          formObj: null,
        }
      },
      opCode: "add",
      msgId: "17046",
      timer1: null,
    };
  },
  beforeDestroy() {
    if (this.timer1) {
      clearTimeout(this.timer1);
      this.timer1 = null;
    }
  }
};
</script>
